import React from 'react';
import PropTypes from 'prop-types';
import LoadingIndicator from '../../Common/LoadingIndicator/LoadingIndicator';
import ListBuilder from '../../Common/ListBuilder/ListBuilder';

const BaselinePushdownForm = ({pushdownLocations, isFormValid, updateLocationsToPush, projectEnabled, isLoading}) => {
    return (
        <LoadingIndicator isLoading={isLoading}>
            <form noValidate className={isFormValid ? "baseline-pushdown-form" : "baseline-pushdown-form was-validated"}>
                {projectEnabled ? 
                    <div className="alert alert-secondary">
                        This feature does not add the project to the location. To include the project, go to Admin &gt; Projects and use the Project Pushdown feature.
                    </div> : null}
                {pushdownLocations.length > 0 ?
                    <ListBuilder
                        list={pushdownLocations}
                        addToList={updateLocationsToPush}
                        selectLabel="Locations to be pushed down to"
                        selectPlaceholder="Search for a locations to add..." />
                    : "No locations were found"}
            </form>
        </LoadingIndicator>
    );
}

BaselinePushdownForm.propTypes = {
    pushdownLocations: PropTypes.array.isRequired,
    isFormValid: PropTypes.bool.isRequired,
    updateLocationsToPush: PropTypes.func.isRequired,
    projectEnabled: PropTypes.bool.isRequired,
    isLoading: PropTypes.bool.isRequired
}

export default BaselinePushdownForm;